import React, { useMemo } from "react";
import { Grid, Hidden, Typography, Box, ButtonBase } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useLocale } from "hooks";
import { useStyles } from "styling/mainStyles";
import { PLAY_STORE_LINK } from "constants/index";

const Home = () => {
  const { t } = useTranslation();
  const { localeState } = useLocale();
  const { locale } = localeState;
  const classes = useStyles();

  const renderDescription = useMemo(() => {
    return (
      <Box className="description-wrapper">
        <Typography variant="h4" color="primary">
          {t("homeTitle")}
        </Typography>
        <Typography style={{ whiteSpace: "pre-line" }}>
          {t("homeDesc")}
        </Typography>
        <ButtonBase
          className={classes.googlePlayButton}
          onClick={() => window.open(PLAY_STORE_LINK)}
        >
          <img
            src={`img/google-play-badge_${locale}.png`}
            alt="My Daily Budget in Google Play"
          />
        </ButtonBase>
      </Box>
    );
  }, [locale, t]);

  return (
    <Grid className={classes.homeWrapper} container spacing={0}>
      <Hidden smDown>
        <Grid item xs={8}>
          <Box className={classes.homeImgDesktopWrapper}>
            <img
              className="splash"
              src="img/splash.png"
              alt="My Daily Budget Dashboard"
            />
            <img
              className="dash"
              src={`img/home_${locale}.png`}
              alt="My Daily Budget Home Screen"
            />
          </Box>
        </Grid>
        <Grid item xs={4}>
          {renderDescription}
        </Grid>
      </Hidden>
      <Hidden mdUp>
        <Grid item xs={12}>
          {renderDescription}
          <img src={`img/home_${locale}.png`} alt="My Daily Budget Dashboard" />
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default Home;
